import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const elecItems = [
  "Remplacement et réparation de moteur",
  "Remplacement de télécommande",
  "Remplacement de point de commande",
  "Recalibrage du moteur",
  "Diagnostic électrique complet",
  "Réinitialisation des fins de course",
];

export default function Electrique() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-4">
              <strong className="text-brand-blue">Volet roulant électrique</strong> : ce que nous réparons
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Un volet électrique qui ne répond plus, un moteur qui fait du bruit ou une télécommande sans réaction : ces pannes sont courantes et notre équipe les traite au quotidien à Strasbourg. Nous réparons ou remplaçons le <a href="/moteur-somfy" className="text-brand-cyan hover:underline">moteur</a>, le récepteur radio, la télécommande ou le point de commande mural. Nous effectuons également un recalibrage complet du système pour garantir un fonctionnement fluide et silencieux. Toutes les marques de motorisation sont prises en charge sans exception.
            </p>
            <ul className="space-y-3">
              {elecItems.map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-blue text-base font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder
              src="https://readdy.ai/api/search-image?query=Technician%20repairing%20an%20electric%20roller%20shutter%20motor%20with%20a%20multimeter%20and%20professional%20tools%20in%20a%20modern%20French%20home%20interior%20clean%20bright%20lighting%20warm%20neutral%20tones%20professional%20service%20photography%20detailed%20close%20up%20work%20near%20Strasbourg&width=700&height=520&seq=rep-elec&orientation=landscape"
              alt="Réparation de moteur de volet roulant électrique à Strasbourg"
              className="w-full h-[400px] md:h-[500px]"
              loading="lazy"
              width={700}
              height={520}
            />
          </div>
        </div>
      </div>
    </section>
  );
}